import { render, staticRenderFns } from "./CollapseListaDocumentos.vue?vue&type=template&id=69f60665&lang=pug"
import script from "./CollapseListaDocumentos.vue?vue&type=script&lang=js"
export * from "./CollapseListaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CollapseListaDocumentos.vue?vue&type=style&index=0&id=69f60665&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports